import request from "../utils/request";

// ─── 类型定义 ─────────────────────────────────────────────────────────────────

export type AnomalyMetricType = "frequency" | "duplicate";

export interface AnomalyThreshold {
  metricType: AnomalyMetricType;
  timeWindowMinutes: number;
  countThreshold: number;
}

export interface AnomalyEvent {
  id: string;
  userId: string;
  userName: string;
  behaviorType: AnomalyMetricType;
  /** 触发问题文本；仅 duplicate 类型有值，frequency 为空串 */
  questionText: string;
  detail: string;
  windowMinutes: number;
  requestCount: number;
  /** 北京时间 yyyy-MM-dd HH:mm:ss */
  timestamp: string;
}

export interface ThresholdUpdatePayload {
  timeWindowMinutes: number;
  countThreshold: number;
}

export interface PagedResult<T> {
  data: T[];
  total: number;
  page: number;
  pageSize: number;
}

// ─── API 方法 ─────────────────────────────────────────────────────────────────

export async function getThresholds(): Promise<AnomalyThreshold[]> {
  const res = await request.get<AnomalyThreshold[]>("/project/securityrecords/thresholds");
  return res.data;
}

export async function updateThreshold(
  metricType: AnomalyMetricType,
  payload: ThresholdUpdatePayload,
): Promise<AnomalyThreshold> {
  const res = await request.put<AnomalyThreshold>(
    `/project/securityrecords/thresholds/${metricType}`,
    payload,
  );
  return res.data;
}

export async function getAnomalies(params: {
  hours?: number;
  page?: number;
  pageSize?: number;
} = {}): Promise<PagedResult<AnomalyEvent>> {
  const query: Record<string, number> = {};
  if (params.hours) query.hours = params.hours;
  if (params.page) query.page = params.page;
  if (params.pageSize) query.pageSize = params.pageSize;
  const res = await request.get<PagedResult<AnomalyEvent>>("/project/securityrecords/anomalies", {
    params: Object.keys(query).length ? query : undefined,
  });
  return res.data ?? { data: [], total: 0, page: params.page ?? 1, pageSize: params.pageSize ?? 10 };
}
